import { apiSlice } from "../../store/app.api";
import { supabase } from "../../utils/API";

export type DashboardCounts = {
  total_public_users: number;
  total_deputies: number;
  active_deputies: number;
  inactive_deputies: number;
  total_mtrcb_users: number;
  total_malls: number;
  total_cinemas: number;
  exempted_deputies: number;
};

export type MobileActivityItem = {
  date: string;
  label: string;
  active_users: number;
};

export type ReportChartItem = {
  date: string;
  label: string;
  Movie: number;
  TV: number;
  Others: number;
  total: number;
};

export type ReportTotals = {
  movie: number;
  tv: number;
  others: number;
  total: number;
};

export type DashboardResponse = {
  year: number;
  counts: DashboardCounts;
  mobile_activity: MobileActivityItem[];
  reports_this_week: ReportChartItem[];
  report_totals: ReportTotals;
};

export type DashboardParams = {
  year?: number;
  activityDays?: number;
};

const dashboardApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getDashboard: build.query<DashboardResponse, DashboardParams | void>({
      queryFn: async (params) => {
        const currentYear = new Date().getFullYear();

        const { data, error } = await supabase.rpc("get_admin_dashboard_v1", {
          p_year: params?.year ?? currentYear,
          p_activity_days: params?.activityDays ?? 15,
        });

        if (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: error.message,
            } as any,
          };
        }

        return {
          data: data as DashboardResponse,
        };
      },
      providesTags: [
        "city",
        "messages",
        "movies",
        "mall",
        "Cinema",
        "channels",
        "reports",
        "users",
      ],
    }),
  }),
  overrideExisting: true,
});

export const { useGetDashboardQuery } = dashboardApi;